import Cadastro from '@/pages/empresa/Cadastro'
import Listar from '@/pages/empresa/Listar'

export const empresasRoutes = [
    {
        path: '/empresas',
        name: 'empresas',
        component: Listar
    },
    {
        path: '/empresas/cadastro',
        name: 'empresaCadastro',
        component: Cadastro,
    },
    {
        path: '/empresas/:id/cadastro',
        name: 'empresaEditar',
        component: Cadastro,
        props: true
    },
]

export default{}